exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mobile-page[data-v-3af8c57e]  video{width:100% !important}.box[data-v-3af8c57e]{min-height:100px;padding:10px;background:#f5f5f5}.box[data-v-3af8c57e]  img{max-width:100%;height:auto}", ""]);

// exports
